import React from 'react';
import ReactDOM from 'react-dom/client';
import Footer from './components/common/footer/footer';
import { ThemeProvider } from '@mui/material/styles';
import customTheme from './styles/themes/theme';
import { AuthContextProvider } from './context/AuthContext';
import { CommonDataContextProvider } from './context/commonDataContext';


export const mountFooter = () => {
  const footerEl = document.getElementById('portal-footer');
  if (!footerEl) return;

  const footerRoot = ReactDOM.createRoot(footerEl);
  footerRoot.render(
    <AuthContextProvider>
      <CommonDataContextProvider>
        <ThemeProvider theme={customTheme}>
          <Footer />
        </ThemeProvider>
      </CommonDataContextProvider>
    </AuthContextProvider>
  );
};

